import {ChangeDetectionStrategy, Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild} from "@angular/core";

import {ButtonModule} from "primeng/button";
import {DynamicDialogConfig, DynamicDialogRef} from "primeng/dynamicdialog";
import {Subscription} from "rxjs";
import {receiverAuthenticationWsClientInjectionToken} from "../../ws-clients/receiver-authentication/receiver-authentication-ws-client-injection-token";
import {IReceiverAuthenticationWsClient} from "../../ws-clients/receiver-authentication/i-receiver-authentication-ws.client";
import * as QRCode from "qrcode";

@Component({
  selector: "app-qr-code-modal",
  standalone: true,
  imports: [ButtonModule],
  templateUrl: "./qr-code-modal.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class QrCodeModalComponent implements OnInit, OnDestroy {
  @ViewChild("qrCanvas", {static: true}) qrCanvas!: ElementRef<HTMLCanvasElement>;

  public connectionCode: string | null = null;
  private readonly _subscriptions: Subscription = new Subscription();

  constructor(
    private readonly _dialogRef: DynamicDialogRef,
    private readonly _dialogConfig: DynamicDialogConfig<{ connectionCode: string }>,
    @Inject(receiverAuthenticationWsClientInjectionToken) private readonly _receiverAuthenticationWsClient: IReceiverAuthenticationWsClient
  ) {}

  ngOnInit(): void {
    this.connectionCode = this._dialogConfig.data?.connectionCode ?? null;
    this._generateQrCode(this.connectionCode);

    this._subscriptions.add(
      this._receiverAuthenticationWsClient.getReceiverRegistered$().subscribe((receiverRegisteredMessage) => {
        const formattedConnectionCode: string | undefined = this.connectionCode?.replaceAll("-", "").toLowerCase();

        if (receiverRegisteredMessage.connectionCode === formattedConnectionCode) {
          this.close();
        }
      })
    );
  }

  ngOnDestroy(): void {
    this._subscriptions.unsubscribe();
  }

  public close(): void {
    this._dialogRef.close();
  }

  private _generateQrCode(code: string | null): void {
    if (!code || !this.qrCanvas) return;

    QRCode.toCanvas(this.qrCanvas.nativeElement, code, {
      width: 250,
      margin: 2,
      color: {
        dark: "#000000",
        light: "#ffffff"
      }
    });
  }
}
